<style lang="less">
    .main-drops {
        min-width: 150px;
        user-select: none;
    }
    @media screen and (max-height: 600px) {
        .main-dropsmenu {
            overflow: auto;
            max-height: 200px;
        }
    }
</style>

<template>
    <div
        class="main-drops menu-container"
        draggable="false"
        v-show="showDropdown"
        v-click-outside="closeDrop"
        :style="{ top: dropsTop + 'px', left: dropsLeft + 'px', border: dropType > 9 ? 'none' : '' }"
    >
        <keep-alive>
            <component
                class="main-dropsmenu"
                ref="mianDrop"
                style="margin-top: 6px; margin-bottom: 6px"
                :is="activedDrops"
                @closeDrop="closeDrop"
            ></component>
        </keep-alive>
        <ExpandDrop @closeDrop="closeDrop" :mainWidth="mainWidth" />
    </div>
</template>

<script lang="ts">
    const TabTypeMap = {
        0: "FileDrop",
        1: "EditDrops",
        2: "SelectDrops",
        3: "InsertDrop",
        4: "ArrangeDrops",
        5: "ViewDrop",
        6: "HelpDrops",
        7: "SymbolDrop",
        8: "AIDrop",
        9: "PluginDrop",
    };
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import ExpandDrop from "./ExpandDrops.vue";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            FileDrop: () => import("./FileDrops.vue"),
            ArrangeDrops: () => import("./ArrangeDrops.vue"),
            SelectDrops: () => import("./SelectDrops.vue"),
            InsertDrop: () => import("./InsertDrops.vue"),
            ViewDrop: () => import("./ViewDrops.vue"),
            ExpandDrop,
            EditDrops: () => import("./EditDrops.vue"),
            HelpDrops: () => import("./HelpDrops.vue"),
            SymbolDrop: () => import("./SymbolDrops.vue"),
            AIDrop: () => import("@/app/components/DropMenus/AIDrops.vue"),
            PluginDrop: () => import("./PluginDrops.vue"),
        },
    })
    export default class MainDrops extends Vue {
        closeExpand() {
            this.$store.commit("setStatus", {
                type: "showDropExpand",
                data: false,
            });
        }
        closeDrop() {
            if (!this.showDropdown) return;
            this.showDropdown = false;
            this.$bus.$emit("closeShowAll");
            this.$store.commit("setStatus", {
                type: "showDropExpand",
                data: false,
            });
            this.$store.commit("setStatus", {
                type: "activeTabType",
                data: -1,
            });
            this.activeFunc = "";
        }
        get activeFunc() {
            return this.$store.state.ui.activeFunc;
        }
        set activeFunc(v) {
            this.$store.commit("setStatus", {
                type: "activeFunc",
                data: v,
            });
        }
        get showDropdown() {
            return this.$store.state.ui.showDropdown;
        }
        set showDropdown(v: boolean) {
            this.$store.commit("setStatus", {
                type: "showDropdown",
                data: v,
            });
        }
        get dropType() {
            return this.$store.state.ui.dropType;
        }
        get dropsTop() {
            return this.$store.state.ui.dropTop;
        }
        get dropsLeft() {
            return this.$store.state.ui.dropLeft;
        }
        get activedDrops() {
            return TabTypeMap[this.dropType];
        }
        get compChange() {
            const { activedDrops, showDropdown } = this;
            return { activedDrops, showDropdown };
        }
        mainWidth: number = 0;
        // 同时监听两个变量的变化
        @Watch("compChange")
        compLoaded(val) {
            if (val.showDropdown) {
                setTimeout(() => {
                    if (this.$refs.mianDrop) {
                        let dom = (this.$refs.mianDrop as any).$el as HTMLElement,
                            padding = 16;
                        this.mainWidth = dom.offsetWidth + padding;
                    }
                }, 200);
            }
        }

        mounted() {
            this.$bus.$on("closeMenuDrop", () => {
                this.closeDrop();
            });
        }

        beforeDestroy() {
            this.$bus.$off("closeMenuDrop");
        }

        created() {}
    }
</script>
